const country = state => state.values.country;

export default {
    country,
};
